/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportDoorProxiesV2MutationRequest,
  ExportDoorProxiesV2MutationResponse,
  ExportDoorProxiesV2400,
  ExportDoorProxiesV2500,
} from '../types/ExportDoorProxiesV2'

function getExportDoorProxiesV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/contacts/doorproxies/export/v2/` as const,
  }
  return res
}

/**
 * @description Start an async door proxies export.
 * @summary Start an async unmatched doors (door proxies) export
 * {@link /api/v1/contacts/doorproxies/export/v2/}
 */
export async function exportDoorProxiesV2(
  data: ExportDoorProxiesV2MutationRequest,
  config: Partial<RequestConfig<ExportDoorProxiesV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportDoorProxiesV2MutationResponse,
    ResponseErrorConfig<ExportDoorProxiesV2400 | ExportDoorProxiesV2500>,
    ExportDoorProxiesV2MutationRequest
  >({
    method: 'POST',
    url: getExportDoorProxiesV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
